module.exports = ".row{\r\n    margin-top: 150px;\r\n    margin-bottom: 50px;\r\n}\r\nimg{\r\n    width: 800px;\r\n    height: 350px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/interior/interior.component.css
// module id = ./src/app/pages/interior/interior.component.css
// module chunks = main